// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table___qVFQ","tableHeaderContainer":"styles_tableHeaderContainer__3QrdE","tableRow":"styles_tableRow__2X92f"};